import {
  GET_POSTS,
  ADD_POST,
  UPDATE_POST,
  DELETE_POST,
  POST_ERROR,
  CLEAR_POSTS,
  CLEAR_POST_MESSAGES,
  FAVORITE_POST,
  ADD_POST_COMPLETE,
} from "../types";

const PostReducer = (state, action) => {
  switch (action.type) {
    case GET_POSTS:
      const res_posts = action.payload;
      return {
        ...state,
        posts: res_posts,
        loading: false,
        postAdded: false,
      };
    case ADD_POST:
      return {
        ...state,
        posts: [action.payload, ...state.posts],
        loading: false,
        postAdded: true,
        message: "add_post_success",
      };
    case ADD_POST_COMPLETE:
      return {
        ...state,
        postAdded: false,
      };
    case UPDATE_POST:
      return {
        ...state,
        posts: state.posts.map((post) =>
          post.id === action.payload.id ? action.payload : post
        ),
        loading: false,
      };
    case FAVORITE_POST:
      return {
        ...state,
        posts: state.posts.map((post) =>
          post.id === action.payload.id ? action.payload : post
        ),
        loading: false,
        message: "favorite_post_success",
      };
    case DELETE_POST:
      return {
        ...state,
        posts: state.posts.filter((post) => post.id !== action.payload),
        loading: false,
        message: "delete_post_success",
      };
    case POST_ERROR:
      return {
        ...state,
        message: action.payload,
      };
    case CLEAR_POST_MESSAGES:
      return {
        ...state,
        message: null,
      };
    case CLEAR_POSTS:
      return {
        ...state,
        posts: [],
        message: null,
      };
    default:
      return state;
  }
};

export default PostReducer;